import React, { useState, Fragment } from 'react';
import UploadFormTable from '../../Reusable/Attachment/UploadFormTable/UploadFormTable';
import { getFilesForUpload } from '../../../utils/attachment';

const UploadFieldDemo = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFiles2, setUploadedFiles2] = useState([]);
  const [uploadedFiles3, setUploadedFiles3] = useState([]);
  const [uploadedFiles4, setUploadedFiles4] = useState([]);

  const onFileChangeHandler = (e) => {
    const filesForUpload = getFilesForUpload(e.target.files);
    filesForUpload &&
      setUploadedFiles((prevState) => prevState.concat(filesForUpload));
  };

  const handleDeleteDocumentHandler = (fileName) => {
    const uploadedDocumentsNames = uploadedFiles?.map((f) => f?.name) || [];
    const uploadedDocumentsAsArray = Array.from(uploadedFiles);
    const index = uploadedDocumentsNames.indexOf(fileName);
    uploadedDocumentsAsArray.splice(index, 1);

    setUploadedFiles(uploadedDocumentsAsArray);
  };

  const onFileChangeHandler2 = (e) => {
    const filesForUpload = getFilesForUpload(e.target.files);
    filesForUpload &&
      setUploadedFiles2((prevState) => prevState.concat(filesForUpload));
  };

  const handleDeleteDocumentHandler2 = (fileName) => {
    const uploadedDocumentsNames = uploadedFiles2?.map((f) => f?.name) || [];
    const uploadedDocumentsAsArray = Array.from(uploadedFiles2);
    const index = uploadedDocumentsNames.indexOf(fileName);
    uploadedDocumentsAsArray.splice(index, 1);
    setUploadedFiles2(uploadedDocumentsAsArray);
  };

  const onFileChangeHandler3 = (e) => {
    const filesForUpload = getFilesForUpload(e.target.files);
    filesForUpload &&
      setUploadedFiles3((prevState) => prevState.concat(filesForUpload));
  };

  const handleDeleteDocumentHandler3 = (fileName) => {
    const uploadedDocumentsNames = uploadedFiles3?.map((f) => f?.name) || [];
    const uploadedDocumentsAsArray = Array.from(uploadedFiles3);
    const index = uploadedDocumentsNames.indexOf(fileName);
    uploadedDocumentsAsArray.splice(index, 1);
    setUploadedFiles3(uploadedDocumentsAsArray);
  };

  const onFileChangeHandler4 = (e) => {
    const filesForUpload = getFilesForUpload(e.target.files);
    filesForUpload &&
      setUploadedFiles4((prevState) => prevState.concat(filesForUpload));
  };

  const handleDeleteDocumentHandler4 = (fileName) => {
    const uploadedDocumentsNames = uploadedFiles4?.map((f) => f?.name) || [];
    const uploadedDocumentsAsArray = Array.from(uploadedFiles4);
    const index = uploadedDocumentsNames.indexOf(fileName);
    uploadedDocumentsAsArray.splice(index, 1);
    setUploadedFiles4(uploadedDocumentsAsArray);
  };

  return (
    <Fragment>
      <UploadFormTable
        name="uploadedFiles"
        onChange={onFileChangeHandler}
        handleDeleteDocument={handleDeleteDocumentHandler}
        uploadedFiles={uploadedFiles}
        placeholder={'Učitajte fajl'}
        enableMultiple={false}
        deleteColWidth={'25%'}
      />
      <UploadFormTable
        name="uploadedFiles2"
        onChange={onFileChangeHandler2}
        handleDeleteDocument={handleDeleteDocumentHandler2}
        uploadedFiles={uploadedFiles2}
        deleteColWidth={'25%'}
      />
      <UploadFormTable
        name="uploadedFiles3"
        onChange={onFileChangeHandler3}
        handleDeleteDocument={handleDeleteDocumentHandler3}
        uploadedFiles={uploadedFiles3}
        enableMultiple={false}
        deleteColWidth={'25%'}
        renderButton={true}
      />
      <UploadFormTable
        name="uploadedFiles4"
        onChange={onFileChangeHandler4}
        handleDeleteDocument={handleDeleteDocumentHandler4}
        uploadedFiles={uploadedFiles4}
        deleteColWidth={'25%'}
        renderButton={true}
      />
    </Fragment>
  );
};

export default UploadFieldDemo;
